/**
 * Set when core-api ended this session (401 SESSION_ENDED, ADR-020), read once by the sign-in page
 * to say why the person is signed out. Kept apart from `api-client.ts`, which tests mock whole.
 */
const SESSION_ENDED_NOTICE_KEY = 'console.sessionEnded';

export function markSessionEnded(): void {
  try {
    sessionStorage.setItem(SESSION_ENDED_NOTICE_KEY, '1');
  } catch {
    // Storage unavailable (a private window): the sign-in page simply shows no notice.
  }
}

/** Whether the last sign-out happened because core-api ended the session. */
export function readSessionEndedNotice(): boolean {
  try {
    return sessionStorage.getItem(SESSION_ENDED_NOTICE_KEY) === '1';
  } catch {
    return false;
  }
}

export function clearSessionEndedNotice(): void {
  try {
    sessionStorage.removeItem(SESSION_ENDED_NOTICE_KEY);
  } catch {
    // Nothing to clear.
  }
}
